import React, { useState } from 'react';

import { Tabs, TabsContent, TabsList, TabsTrigger } from '@playbooks/ui/components/tabs';

export const TabElement = ({ tabs, children }) => {
	const [active, setActive] = useState(tabs[0]);

	// Computed
	const panes = React.Children.toArray(children);

	return (
		<Tabs value={active} onValueChange={setActive} className='rounded-media border bg-surface'>
			<TabsList className='h-auto w-full justify-start rounded-none rounded-t-media border-b bg-surface-hover/50 p-1'>
				{tabs.map((tab, i) => (
					<TabsTrigger key={i} value={tab} className='flex-none'>
						{tab.toUpperCase()}
					</TabsTrigger>
				))}
			</TabsList>
			{panes.map((pane, i) => (
				<TabsContent key={i} value={tabs[i]} className='p-4 pt-2'>
					{pane}
				</TabsContent>
			))}
		</Tabs>
	);
};
